export const id = {
    'nav.today': "Ringkasan Hari Ini",
    'nav.calendar': "Kalender Permintaan",
    'nav.rates': "Tarif & Aturan",
    'nav.automation': "Pusat Otomatisasi",
    'nav.audit': "Log Audit",
    'nav.settings': "Pengaturan",
    'sidebar.status': "Terhubung",
    'stat.occupancy': "Okupansi",
    'stat.adr': "ADR (Rata-rata)",
    'stat.revpar': "RevPAR",
    'stat.revenue': "Est. Pendapatan",
    'stat.trend.vsLastWeek': "vs Mgg Lalu",
    'stat.trend.onPace': "Sesuai Target",
    'dashboard.actions.title': "Tindakan yang Disarankan",
    'dashboard.actions.empty': "Tidak ada tindakan ditemukan.",
    'filter.all': "Semua",
    'filter.pricing': "Harga",
    'filter.restriction': "Batasan",
    'action.approve': "Setujui",
    'action.reject': "Tolak",
    'action.risk.low': "risiko rendah",
    'action.risk.medium': "risiko sedang",
    'action.risk.high': "risiko tinggi",
    'action.label.current': "Saat Ini",
    'action.label.proposed': "Diusulkan",
    'action.metric.impact': "Dampak",
    'action.metric.why': "Mengapa",
    'action.status.executed': "Dieksekusi Otomatis",
    'header.search': "Cari...",
    'header.logout': "Keluar",
    'auto.level.title': "Tingkat Autopilot",
    'auto.level.manual': "Manual",
    'auto.level.manual.desc': "Anda menyetujui setiap rekomendasi.",
    'auto.level.assisted': "Terbantu",
    'auto.level.assisted.desc': "Setuju otomatis risiko rendah. Tinjau perubahan besar.",
    'auto.level.auto': "Otomatis Penuh",
    'auto.level.auto.desc': "AI mengelola harga 24/7 dalam batasan Anda.",
    'auto.level.active': "Aktif",
    'auto.guardrails.title': "Batas Keamanan",
    'auto.guardrails.maxIncrease': "Maks Kenaikan Harian",
    'auto.guardrails.maxIncrease.desc': "Cegah lonjakan harga.",
    'auto.guardrails.maxDecrease': "Maks Penurunan Harian",
    'auto.guardrails.maxDecrease.desc': "Cegah harga terlalu rendah.",
    'auto.guardrails.minRate': "Harga Dasar",
    'auto.guardrails.minRate.desc': "Jangan pernah jual di bawah harga ini (Bersih).",
    'auto.emergency.title': "Kontrol Darurat",
    'auto.emergency.label': "Hentikan Darurat",
    'auto.emergency.desc': "Segera jeda semua otomatisasi.",
    'auto.emergency.btn': "JEDA SISTEM",
    'rates.filter.all': "Semua Tipe Kamar",
    'rates.filter.next14': "14 Hari Ke Depan",
    'rates.export': "Ekspor",
    'audit.table.time': "Waktu",
    'audit.table.actor': "Aktor",
    'audit.table.category': "Kategori",
    'audit.table.action': "Tindakan",
    'audit.table.details': "Detail",
    'audit.table.status': "Status",
    'settings.pms.title': "Koneksi PMS",
    'settings.pms.connected': "Terhubung ke",
    'settings.pms.disconnect': "Putuskan",
    'settings.account.title': "Akun",
    'settings.account.role': "Peran",
    'settings.restart': "Mulai Ulang Onboarding",
    'onboard.title': "Hubungkan PMS",
    'onboard.desc': "Pilih Sistem Manajemen Properti (PMS) Anda untuk sinkronisasi.",
    'onboard.connecting': "Menghubungkan...",
    'onboard.connect': "Hubungkan",
    'onboard.success.title': "Pengaturan Selesai!",
    'onboard.success.desc': "**SynthHotel Berlin** sekarang tersinkronisasi.",
    'onboard.success.sub': "Mengimpor 3 Tipe Kamar, 14 Rencana Tarif, dan 243 Pemesanan.",
    'onboard.btn.dashboard': "Ke Dasbor",
    'action.dynamic.weekend.title': "Naikkan Harga Akhir Pekan",
    'action.dynamic.weekend.desc': "Okupansi > 75% Sabtu, permintaan kuat (+12 kamar dlm 24j).",
    'action.dynamic.minstay.title': "Aktifkan Min Inap 2 Malam",
    'action.dynamic.minstay.desc': "Konser Taylor Swift diumumkan. Cegah inap 1 malam.",
    'action.dynamic.distress.title': "Turunkan Harga (Permintaan Rendah)",
    'action.dynamic.distress.desc': "Okupansi 35% Selasa depan. Kompetitor turun €10.",
    'action.dynamic.gap.title': "Isi Kekosongan: Hapus CTA",
    'action.dynamic.gap.desc': "Celah satu malam. Hapus 'Tutup Kedatangan' untuk menjual.",
};
